export * from './contracts';
export var ChainId;
(function (ChainId) {
    ChainId[ChainId["CRONOS_MAINNET"] = 25] = "CRONOS_MAINNET";
    ChainId[ChainId["CRONOS_TESTNET"] = 338] = "CRONOS_TESTNET";
})(ChainId || (ChainId = {}));
